import React from 'react'

const About = () => {
  return (
    <div>
        <h1 className='text-6xl mb-4'>About Github Finder Application</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta dignissimos libero dolorum optio eius velit. Repudiandae asperiores eum autem debitis sunt similique nobis, rerum sit minima, fuga earum blanditiis modi.
        Cum mollitia beatae dolore, nobis laudantium tempora ipsa temporibus magnam eveniet pariatur quasi neque ducimus. Fugit atque labore delectus quis! Vitae eius nam rem voluptates libero dolorem, quia iure illo!
        Error ut neque corrupti tenetur, eveniet nostrum distinctio fuga culpa eaque hic dolorum impedit deleniti maxime porro reiciendis dolore. A, quo placeat doloribus reprehenderit laborum quam dolorum accusantium consequuntur consectetur?
        Nulla placeat velit, suscipit quam eum ipsum quia commodi sapiente officia? Vel nulla dolor voluptas doloremque beatae alias suscipit laboriosam tempora voluptatem animi optio, quod, magnam et ex harum esse.
        Eius ipsam voluptas quasi fugiat nesciunt cupiditate, natus eligendi dolorum dolor, repellat laudantium ratione odit dignissimos quis. Cum et modi, earum saepe facere similique sint distinctio? Excepturi beatae magnam suscipit.</p>
    </div>
  )
}

export default About